import { forwardRef } from "react";
import { Text } from "@react-three/drei";
import { useThree } from "@react-three/fiber";

// On mobile the camera sits much further back (to keep a narrow aspect from
// clipping the scene) and the whole group is scaled down to fit — both
// shrink in-scene labels below a readable size. Boost the world-space font
// size on mobile so text stays legible without touching the geometry scale
// that keeps everything else correctly framed.
const MOBILE_TEXT_BOOST = 1.9;

const ResponsiveText = forwardRef(function ResponsiveText(
  { fontSize = 0.2, ...props },
  ref,
) {
  const { size } = useThree();
  const boosted = size.width < 768 ? fontSize * MOBILE_TEXT_BOOST : fontSize;
  return <Text ref={ref} fontSize={boosted} {...props} />;
});

export default ResponsiveText;
